import Abstract from "../../../abstract-view/abstract.js";

export default class Wrapper extends Abstract {
  constructor(element) {
    super();

    this._element = element;

    this._productsElement = null;
    this._paginationElement = null;
    this._filtersWrapperElement = null;
    this._actionsElement = null;
    this._productsWrapperElement = null;
    this._subcategoriesWrapperElement = null;
    this._linksListElement = null;
    this._featuresElement = null;
    this._selectedElement = null;
  }

  getInitTotal() {
    return +this.getElement().dataset.initTotal;
  }

  removeInitTotal() {
    delete this.getElement().dataset.initTotal;
  }

  getProductsElement() {
    this._productsElement = this._element.querySelector(`.products-list`);

    return this._productsElement;
  }

  getPaginationElement() {
    if (!this._paginationElement) {
      this._paginationElement = this._element.querySelector(`.pagination-wrapper`);
    }

    return this._paginationElement;
  }

  getFiltersWrapperElement() {
    if (!this._filtersWrapperElement) {
      this._filtersWrapperElement = this._element.querySelector(`.category-filter`);
    }

    return this._filtersWrapperElement;
  }

  getActionsElement() {
    if (!this._actionsElement) {
      this._actionsElement = this._element.querySelector(`.sorting-view-wrapper`);
    }

    return this._actionsElement;
  }

  getProductsWrapperElement() {
    if (!this._productsWrapperElement) {
      this._productsWrapperElement = this._element.querySelector(`.category-products-wrapper`);
    }

    return this._productsWrapperElement;
  }

  getSubcategoriesWrapperElement() {
    if (!this._subcategoriesWrapperElement) {
      this._subcategoriesWrapperElement = this._element.querySelector(`.subcategories-wrapper`);
    }

    return this._subcategoriesWrapperElement;
  }

  getFeaturesElement() {
    if (!this._featuresElement) {
      this._featuresElement = this._element.querySelector(`.product-features-list`);
    }

    return this._featuresElement;
  }

  getLinksListElement() {
    if (!this._linksListElement) {
      this._linksListElement = this._element.querySelector(`.category-links`);
    }

    return this._linksListElement;
  }

  getSelectedElement() {
    this._selectedElement = this._element.querySelector(`.selected-list`);

    return this._selectedElement;
  }

  makeResponsible() {
    this.getFiltersWrapperElement().classList.add(`${this.getFiltersWrapperElement().classList[0]}_responsive`);
  }

  makeDefault() {
    this.getFiltersWrapperElement().classList.remove(`${this.getFiltersWrapperElement().classList[0]}_responsive`);
  }
}
